module.exports = __webpack_public_path__ + "static/media/cd-usb-img.dfdb3125.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/how-it-works-assessment/cd-usb-img.png
// module id = 385
// module chunks = 0